export interface IUserGroups {
  pinHash?: any;
  groups: string[];
}

export enum UserType {
  Unknown = 'Unknown',
  Tech = 'Tech',
  Imagery = 'Imagery',
  SkyTeam = 'Post',
  Client = 'Client',
}

export enum CognitoKey {
  SuperAdmins = 'superAdmins',
  LocalSetupClientUsers = 'localSetupClientUsers',
  LocalClientUsers = 'localClientUsers',
  SkyTeamMembers = 'skyTeamMembers',
  ImageryTeamMembers = 'imageryTeamMembers',
  OrgUsers = 'orgUsers',
  OrgAdmins = 'orgAdmins',
}

export interface UserGroupOption {
  displayName: string;
  cognitoKey: CognitoKey;
  requiresPin: boolean;
}

export const USER_GROUP_OPTIONS: UserGroupOption[] = [
  { displayName: 'Super Admin', cognitoKey: CognitoKey.SuperAdmins, requiresPin: false },
  { displayName: 'Setup Admin', cognitoKey: CognitoKey.LocalSetupClientUsers, requiresPin: false },
  { displayName: 'Robot User', cognitoKey: CognitoKey.LocalClientUsers, requiresPin: true },
  { displayName: 'SkyTeam Member', cognitoKey: CognitoKey.SkyTeamMembers, requiresPin: false },
  { displayName: 'Imagery Member', cognitoKey: CognitoKey.ImageryTeamMembers, requiresPin: false },
  { displayName: 'Organization User', cognitoKey: CognitoKey.OrgUsers, requiresPin: false },
  { displayName: 'Org Admin', cognitoKey: CognitoKey.OrgAdmins, requiresPin: false },
];

export const USER_TYPE_GROUPS: Record<UserType, CognitoKey[]> = {
  [UserType.Unknown]: [],
  [UserType.Tech]: [CognitoKey.SuperAdmins, CognitoKey.LocalSetupClientUsers, CognitoKey.LocalClientUsers],
  [UserType.Imagery]: [CognitoKey.ImageryTeamMembers, CognitoKey.LocalClientUsers],
  [UserType.SkyTeam]: [CognitoKey.SkyTeamMembers],
  [UserType.Client]: [CognitoKey.OrgUsers],
};